import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryShowcase from './components/CategoryShowcase';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';
import ArticleSection from './components/ArticleSection';
import NewsletterSection from './components/NewsletterSection';
import Footer from './components/Footer';
import { SITE_URL } from '@/constants';

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Hipobuy Spreadsheet Hub",
  "url": SITE_URL,
  "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg",
  "description": "Independent educational resource providing guides, comparisons, and information about shopping spreadsheets. Not affiliated with any shopping agent platform.",
  "sameAs": []
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Hipobuy Spreadsheet Hub",
  "url": SITE_URL,
  "description": "The ultimate Hipobuy Spreadsheet resource center. Discover organized product finds across 14 categories, read in-depth shopping guides, and compare spreadsheet platforms to make smarter purchasing decisions.",
  "inLanguage": "en",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": SITE_URL + "/search?q={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <main className="w-full min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <HeroSection />
      <CategoryShowcase />
      <StatsSection />
      <CTASection />
      <ArticleSection />
      <NewsletterSection />
      <Footer />
    </main>
  );
}